import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import HeaderSectionContainer from '../containers/HeaderSection/HeaderSection.container'
import { Image404, Root, Text } from './NotFound.styles'

/**
 * The NotFound' page.
 */
const NotFound = () => (
  <BrandLayout header={<HeaderSectionContainer />}>
    <Root>
      <Text>La página solicitada no existe</Text>
      <Image404 alt="La página solicitada no existe" src="/assets/images/404.svg" />
    </Root>
  </BrandLayout>
)

export default NotFound
